import { useQuery } from '@tanstack/react-query';

import { getCommissions } from '~/services/AgentHub/AgentService';

import { getCommissionsParams } from '~/types/services/agentHub';

export const commissionQueryKeys = {
  all: ['commissions'] as const,
  lists: () => [...commissionQueryKeys.all, 'list'] as const,
  list: (params: getCommissionsParams) => [...commissionQueryKeys.lists(), params] as const,
};

export function useListCommissions(params: getCommissionsParams) {
  return useQuery({
    placeholderData: (prev) => {
      return {
        rows: prev?.rows ?? [],
        total: prev?.total ?? 0,
      };
    },
    queryKey: commissionQueryKeys.list(params),
    queryFn: async () => {
      return await getCommissions(params);
    },
  });
}
